// Login/ro'yxatdan o'tishdan keyin qaytish manzili (?next=/elon-joylash). Faqat sayt ichidagi yo'l qabul qilinadi —
// «//boshqa-sayt.uz» yoki «https://...» kabi tashqi manzilga yo'naltirib bo'lmaydi.
export function nextFrom(search) {
  try {
    const n = new URLSearchParams(search).get('next');
    return n && n.startsWith('/') && !n.startsWith('//') && !n.startsWith('/\\') ? n : null;
  } catch { return null; }
}

export const loginUrl = (next) => `/login?next=${encodeURIComponent(next)}`;
